module.exports = __webpack_public_path__ + "static/bayan-logo-00642af7b45298cf550496c044ab3777.png";